var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChanged({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38209 18.9612L7.83398 19.4398L7.28588 18.9612C2.67674 14.9366 0.333984 11.4225 0.333984 8.3335C0.333984 3.95905 3.74819 0.833496 7.83398 0.833496C11.9198 0.833496 15.334 3.95905 15.334 8.3335C15.334 11.4225 12.9912 14.9366 8.38209 18.9612ZM2.00065 8.3335C2.00065 10.7079 3.92283 13.6948 7.83398 17.2197C11.7451 13.6948 13.6673 10.7079 13.6673 8.3335C13.6673 4.914 11.0306 2.50016 7.83398 2.50016C4.63741 2.50016 2.00065 4.914 2.00065 8.3335ZM5.23036 6.54542H8.77347L3.9114 11.4075L5.00406 12.5002L9.86614 7.63809V11.1812H11.4114V5.00016H5.23036V6.54542Z",
    fill: "#00A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanged);
export default __webpack_public_path__ + "static/media/changed.cc44e2abc2229e8273d37b15dadb71ca.svg";
export { ForwardRef as ReactComponent };